<template>
  <div
    class="study-all-combos studyallcombos"
    :class="{ studyallcombos_bordered: viewProps.combos_columns_line }"
    :data-tst="`allhands_${tstPrefix || 'all'}`"
    @mouseleave="handleMouseleave"
    @mouseenter="$emit('allhands:mouseenter'), (mouseover = true)"
  >
    <div
      class="studyallcombos_inner"
      :style="`width:calc(${hands.totalRange < 1 ? 100 * (1 / hands.totalRange) : 100}%)`"
    >
      <div
        v-for="hand in hands.items"
        :key="hand.id"
        :data-tst="`allhands_${tstPrefix || 'all'}_${hand.id}`"
        :class="{
          studyallcombos_item_active: !activeHandsIds
            ? false
            : !mouseover
              ? activeHandsIds.includes(hand.id)
              : isPinned
                ? activeHandsIds.includes(hand.id)
                : false,
        }"
        class="studyallcombos_item"
        :style="`${useHex ? hand.backgrounds.hex : hand.backgrounds.vars};--hand-range: ${
          hand.range
        };`"
        @mouseenter="handleMouseenter(hand)"
        @click="handleClick(hand)"
      ></div>
    </div>

    <slot name="message"></slot>

    <div
      v-if="hasLegend"
      class="studyallcombos_legend"
    >
      <div
        v-for="(item, idx) in legendItems"
        :key="item.id + idx"
        class="text-nowrap f-center"
        style="max-width: 1px"
        :style="
          idx === legendItems.length - 1
            ? 'justify-content:flex-end'
            : idx === 0
              ? 'justify-content:flex-start'
              : ''
        "
      >
        <span
          v-if="idx === 0"
          style="padding: 0 0.125rem 0 0"
          >EQ</span
        >
        {{ numFixedUnit(item.players[0].eq * 100, 'eq') }}%
      </div>
    </div>
  </div>
</template>

<script>
import { getComboStrategyClrs, toggleCombos } from '@/helpers/solution'
import { throttle } from 'lodash'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'StudyAllHandsHero',
  mixins: [format_mix],
  props: {
    activeHandsIds: { default: () => [] },
    customCombos: Array,
    isPinned: Boolean,
    useHex: Boolean,
    studyFilter: Object,
    viewProps: Object,
    hasLegend: Boolean,
    tstPrefix: String,
  },
  emits: ['allhands:mouseenter', 'combo:click', 'combo:mouseenter', 'combo:mouseleave'],
  data() {
    return {
      mouseover: false,
    }
  },
  methods: {
    handleClick(item) {
      this.$emit('combo:click', item)
    },
    handleMouseenter: throttle(function (item) {
      // handleMouseenter(item) {
      if (!this.mouseover) return
      requestAnimationFrame(() => {
        // requestAnimationFrame(() => {
        this.$emit('combo:mouseenter', item)
        // })
      })
      // },
    }, 60),
    handleMouseleave() {
      this.mouseover = false
      this.$emit('combo:mouseleave')
    },
  },
  computed: {
    hands() {
      let hands = []
      const heroIndex = 0
      if (this.studyFilter) {
        const { combos } = toggleCombos({
          combos: this.customCombos,
          filter: this.studyFilter,
        })
        hands = combos.filter(c => c.players[heroIndex].range)
        if (this.studyFilter.actions.length) {
          hands = hands.map(c => ({
            ...c,
            solution: c.solution.filter(i => this.studyFilter.actions.some(a => a.code === i.code)),
          }))
        }
      } else {
        hands = this.customCombos.filter(c => c.players[heroIndex].range)
      }

      // since all combos in row should take up all space we can use normalized range by default
      const rangeKey =
        this.viewProps.rangeKey === 'range' ? 'range_normalized' : this.viewProps.rangeKey

      let totalRange = 0
      hands = hands.sort((a, b) => (a.players[heroIndex].eq < b.players[heroIndex].eq ? -1 : 1))

      const items = hands.map(hand => {
        const backgrounds = getComboStrategyClrs({
          solution: hand.solution,
          strategyKey: 'strategy',
          range: 1,
        })
        const range = hand.players[heroIndex][rangeKey]
        const r = {
          range,
          ...hand,
          backgrounds,
          x: totalRange,
        }
        totalRange += range
        return r
      })
      // .sort((a, b) => (a.hero.eq < b.hero.eq ? -1 : 1))

      const res = {
        items,
        totalRange,
      }
      // console.log('hands', res)
      // debugger
      return res
    },
    legendItems() {
      const hands = this.hands?.items || []
      if (hands.length < 8) {
        return [hands[0], hands[hands.length - 1]].filter(i => i)
      }

      const totalRange = this.hands?.totalRange || 0
      const rangeStep = Math.floor(totalRange / 4)

      let res = [
        hands[0],
        hands.find(h => h.x >= rangeStep),
        hands.find(h => h.x >= rangeStep * 2),
        hands.find(h => h.x >= rangeStep * 3),
        hands[hands.length - 1],
      ]
      res = res.filter(i => i)
      // console.log(res, rangeStep)
      return res
    },
  },
}
</script>

<style lang="scss">
.studyallcombos {
  --height: 5.5rem;
  --clr-back: transparent;
  --radius: 4px;
  --hands-shadow: none;

  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  // overflow: hidden;
  min-height: 0;
  min-width: 0;
  height: var(--height);

  cursor: pointer;
  &_inner {
    display: flex;
    min-height: 0;
    min-width: 0;
    flex-shrink: 0;
    width: 100%;
    overflow: hidden;
    background: var(--clr-back);
    border-radius: var(--radius);
    box-shadow: var(--hands-shadow);
    flex: 1;
  }
  &_legend {
    display: flex;
    justify-content: space-between;
    font-size: 0.8rem;
    line-height: 1;
    padding-top: 0.125rem;
    font-weight: 600;
    color: var(--clr-grey-2);
  }
  &_bordered {
    .studyallcombos_item {
      // --clr-rtc-graph-divider: #4e4e4e;
      --clr-rtc-graph-divider: var(--clr-black-4);
      // box-shadow: -0.5px 0px 0px 0px var(--clr-rtc-graph-divider);
      // box-shadow: -0.5px 0px 0px 0.01px var(--clr-rtc-graph-divider); //  0.01 is for firefox win
      border-right: 0.5px solid var(--clr-rtc-graph-divider); //  0.01 is for firefox win
      box-sizing: content-box;
      &:last-child {
        // box-shadow: none;
        border-right: none;
      }
    }
  }
  &_item {
    width: calc(var(--hand-range) * 100%);
    height: 100%;
    background-repeat: no-repeat;
    background-position-y: 100%;

    &_active {
      filter: brightness(0.55);
    }
    &:hover {
      filter: brightness(0.55);
    }
  }
}
</style>
